var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "home-page" },
    [
      _c("div", { staticClass: "jumbotron bg-light" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col align-self-center" },
            [
              _c("p", [_vm._v("Enter a profession to get started...")]),
              _vm._v(" "),
              _c("Select2", {
                attrs: {
                  value: _vm.professionUUID,
                  "complete-url": _vm.classificationItemEndpoint,
                  "select-by": _vm.idtype.UUID,
                  placeholder: "6311 - Checkout Operators and Office Cashiers"
                },
                model: {
                  value: _vm.professionUUID,
                  callback: function($$v) {
                    _vm.professionUUID = $$v
                  },
                  expression: "professionUUID"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm._m(0)
        ])
      ]),
      _vm._v(" "),
      !_vm.ready ? _c("Loading") : _vm._e(),
      _vm._v(" "),
      !_vm.professionUUID
        ? _c("div", { staticStyle: { "margin-bottom": "20px" } }, [_vm._m(1)])
        : _vm._e(),
      _vm._v(" "),
      _vm.professionUUID
        ? _c(
            "div",
            [
              _c("JobInformation", {
                attrs: { uuid: _vm.professionUUID, "main-occupation": true }
              }),
              _vm._v(" "),
              _c("h2", { staticClass: "text-center text-white underline" }, [
                _vm._v("\n      Other similar jobs\n    ")
              ]),
              _vm._v(" "),
              _vm._m(2),
              _vm._v(" "),
              _vm._l(_vm.similarClassificationItems, function(item) {
                return _c(
                  "div",
                  { key: item["item_id"] },
                  [
                    _c("JobInformation", {
                      attrs: {
                        uuid: item["item_id"],
                        "common-skills": item["skills"],
                        code: item["code"],
                        "compare-code": item["compare_code"]
                      }
                    })
                  ],
                  1
                )
              })
            ],
            2
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col" }, [
      _c("p", [
        _c("strong", [_vm._v("Use the power of the SITH ")]),
        _vm._v(
          " - (Skills Identification & Transfer Helper) to find relevant jobs based on your\n          existing skills and knowledge.\n        "
        )
      ]),
      _vm._v("\n        Check these great examples first:\n        "),
      _c("ul", [
        _c("li", [
          _c("strong", [_vm._v("6311")]),
          _vm._v(" - Checkout Operators and Office Cashiers")
        ]),
        _vm._v(" "),
        _c("li", [
          _c("strong", [_vm._v("1333")]),
          _vm._v(" - Importers, Exporters and Wholesalers")
        ]),
        _vm._v(" "),
        _c("li", [
          _c("strong", [_vm._v("2322")]),
          _vm._v(" - Surveyors and Spatial Scientists")
        ])
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "Pay and concordance information is only available for 4-digit ANZSCO codes. Other codes do not have full\n          functionality at this point."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-group" }, [
      _c("div", { staticClass: "card" }, [
        _c("h5", { staticClass: "card-header" }, [
          _vm._v("Why it is called SITH?")
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "card-body",
            staticStyle: {
              background: "linear-gradient(135deg , #83dade 0%, #97b2ea 100%)"
            }
          },
          [
            _c("p", { staticClass: "card-text" }, [
              _vm._v(
                "\n                We're using data from the\n                "
              ),
              _c(
                "a",
                {
                  attrs: {
                    href:
                      "https://www.nationalskillscommission.gov.au/our-work/jobs-and-education-data-infrastructure-jedi"
                  }
                },
                [
                  _vm._v(
                    "\n                  Jobs and Education Data Infrastructure (JEDI)"
                  )
                ]
              ),
              _vm._v(
                "\n                National Skill Classification dataset to help people find new job opportunities.\n              "
              )
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "card-text" }, [
              _vm._v("\n                So we've "),
              _c("u", [_vm._v("brought balance to the Force")]),
              _vm._v(
                " - the labour force -\n                by making sure the JEDI and the SITH exist in balance.\n              "
              )
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "card-text" }, [
              _vm._v("\n                We are also using "),
              _c(
                "a",
                {
                  attrs: {
                    href:
                      "https://www.abs.gov.au/statistics/labour/earnings-and-work-hours/employee-earnings-and-hours-australia/latest-release"
                  }
                },
                [_vm._v("ABS\n                Data")]
              ),
              _vm._v(
                " to get salary data broken down by gender and ANZSCO code to produce comparative salary information.\n              "
              )
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card" }, [
        _c("h5", { staticClass: "card-header" }, [_vm._v("How does it work?")]),
        _vm._v(" "),
        _c("div", { staticClass: "card-body" }, [
          _c("p", { staticClass: "card-text" }, [
            _vm._v(
              "\n              SITH pulls data from a number of government sources in order to give Australian citizens insights\n                that can help\n                them plan their careers, transition to better paying jobs, or even find a new career that requires\n                similar\n                skills\n                to their previous employment.\n              "
            )
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "card-text" }, [
            _vm._v(
              "\n                These professions are then cross referenced with ABS salary information, so that users could find\n                upwards moves for their careers - better paying jobs that leverage skills they already possess!\n              "
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card" }, [
        _c("h5", { staticClass: "card-header" }, [
          _vm._v("How did we use Aristotle?")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "card-body" }, [
          _c("p", { staticClass: "card-text" }, [
            _vm._v("\n              The "),
            _c(
              "a",
              {
                attrs: {
                  href:
                    "https://aristotle-te-govhack-20-qrjjxm.herokuapp.com/item/6/classificationviewer"
                }
              },
              [_vm._v("ANZSCO")]
            ),
            _vm._v(" and\n                "),
            _c(
              "a",
              {
                attrs: {
                  href:
                    "https://www.nationalskillscommission.gov.au/our-work/australian-skills-classification"
                }
              },
              [_vm._v("Australian Skills Classification")]
            ),
            _vm._v(" were first loaded into an\n                "),
            _c(
              "a",
              {
                attrs: {
                  href:
                    "https://aristotle-te-govhack-20-qrjjxm.herokuapp.com/home/"
                }
              },
              [_vm._v("Aristotle Metadata Registry")]
            ),
            _vm._v(
              ",\n                which exposes a comprehensive API allowing us to search and query the classification.\n              "
            )
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "card-text" }, [
            _vm._v(
              "\n                This was connected to a autocomplete search component, allowing users to search for any profession in\n                milliseconds.\n              "
            )
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "card-text" }, [
            _vm._v(
              "\n                Once a profession was selected, the classification item was fetched from the API, as well as using\n                a classification similarity API to identify other professions with shared skills.\n              "
            )
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "text-center text-white" }, [
      _vm._v(
        "\n      Based on the skills & tools you already know, you may be interested in the following similar occupations.\n      "
      ),
      _c("br"),
      _vm._v("\n      Click a skill or occupation to learn more.\n    ")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }